import { Component, OnInit } from '@angular/core';
import {SidebarService} from "../../services/sidebar.service";
import {CaseCompleteState} from "../../models/docket";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  CaseCompleteState: typeof CaseCompleteState = CaseCompleteState;

  constructor(public sidebarService : SidebarService) { }

  ngOnInit(): void {
    // this.links.push({text:'Dashboard',href:'#'});
  }

}
